import dayjs from 'dayjs';
import Commons from '../../../../Services/Common/Common';

export const POL_BASIC_01_Schema = {
  fields: {
    no: { initial: '', label: '행 식별자' },
    newYn: { initial: 'N', label: '신규 여부' },

    chaebun: { initial: '', label: '채번' },
    coCd: { initial: '', label: '회사코드' },
    date: { initial: dayjs().format('YYYY-MM-DD'), label: '작성일자' },
    name: { initial: '', label: '성명' },
    comment: {
      initial: `<div style="text-align: center"><span style="font-size: 24px"><strong>안전보건경영방침</strong></span></div><div style="text-align: center"><span style="font-size: 20px"><strong><br></strong></span></div><div><u>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</u>은 경영활동 전반에 전 사원의 안전과 보건을 기업의 최우선으로 실천하며, 법규 및 기준을 준수하는 안전보건관리체계를 구축하여 전 직원이 안전하고 쾌적한 환경에서 근무할 수 있도록 다음 사항을 실천한다.<br></div><div><br></div><ol><li>우리는 ‘종사자의 생명 보호’와 ‘안전한 작업환경 조성’을 기업경영활동의 최우선의 목표로 삼는다.</li><li>우리는 사업장에 안전보건관리체계를 구축하여 사업장의 위험요인 제거·통제를 위한 충분한 인적·물적 자원을 제공한다.</li><li>안전보건 목표를 설정하고, 이를 달성하기 위한 세부적인 실행계획을 수립하여 이행한다.</li><li>안전보건 관계 법령 및 관련 규정을 준수하는 내부규정을 수립하여 충실히 이행한다.</li><li>종사자의 참여를 통해 위험요인을 파악하고, 파악된 위험요인은 반드시 개선하고, 교육을 통해 공유한다.</li><li>사업장의 모든 종사자는 자신의 직무와 관련된 위험요인을 인지하게 하고, 위험요인 제거·대체 및 통제기법에 관해 교육·훈련을 실시한다.</li><li>모든 공급자와 계약자가 우리의 안전보건 방침과 안전 요구사항을 준수하도록 한다.</li><li>사업장의 모든 종사자는 안전보건활동에 대한 책임과 의무를 성실히 준수토록 한다.</li></ol><div><br></div><div><br></div><div style="text-align: center">0000년 00월 00일<br></div><div style="text-align: center"><br></div><div style="text-align: right">0000 대표이사 000 (서명)<br></div>`,
      label: '내용',
    },

    fileName: { initial: '', label: '파일명' },
    saveName: { initial: '', label: '저장 파일명' },
    filePath: { initial: '', label: '파일 경로' },
    appShareYn: { initial: 'N', label: '앱 공유' },

    previewFilePath: { initial: '', label: '미리보기 파일 경로' },
    createDate: { initial: '', label: '생성일자' },
    createId: { initial: '', label: '생성자 ID' },
    updateDate: { initial: '', label: '수정일자' },
    updateId: { initial: '', label: '수정자 ID' },
    mapFile: { initial: '', label: '첨부파일' },
  },

  mapper: {
    /** GetPolBasicR1(CoCd, Year, SearchText) — Year는 YYYY 암호화 문자열 */
    search1: {
      CoCd: (_, context) =>
        Commons.EncryptAES(
          context.userInfo?.authCd === 'ADMIN'
            ? context.search?.coCd
            : context.userInfo?.coCd || ''
        ),
      SearchText: (_, context) =>
        Commons.EncryptAES(context.search?.searchText || ''),
    },

    save1: {
      Chaebun: (row) => Commons.EncryptAES(row.chaebun || ''),
      CoCd: (_, context) =>
        Commons.EncryptAES(
          context.userInfo?.authCd === 'ADMIN'
            ? context.search?.coCd
            : context.userInfo?.coCd || ''
        ),
      Date: (row) =>
        Commons.EncryptAES(
          row.date ? dayjs(row.date).format('YYYY-MM-DD') : ''
        ),
      Name: (row) => Commons.EncryptAES(row.name || ''),
      Comment: (row) =>
        Commons.EncryptAES(row.fileName !== '' ? '' : row.comment || ''),
      FileName: (row) => Commons.EncryptAES(row.fileName || ''),
      SaveName: (row) => Commons.EncryptAES(row.saveName || ''),
      FilePath: (row, context) => {
        const _coCd =
          context.userInfo?.authCd === 'ADMIN'
            ? context.search?.coCd
            : context.userInfo?.coCd || '';
        const filePath =
          row.fileName !== ''
            ? `PolicyAndGoals/${_coCd}/POL_BASIC_01/${row.saveName}`
            : '';
        return Commons.EncryptAES(filePath);
      },
      AppShareYn: (row) => Commons.EncryptAES(row.appShareYn === 'Y' ? 'Y' : 'N'),
      UserId: (_, context) => context.userInfo?.userid || '',
    },

    delete1: {
      Chaebun: (row) => Commons.EncryptAES(row.chaebun || ''),
    },
  },
};
